import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {designersList,designersAdd,designersUpdate,designersDelete,designersStatus,designersEdit}=API

const initialState = { 
    data:[],
    singleData:[],
    singleDesigners:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const designersSlice = createSlice({
    name: "designers",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteDesigners(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setDesignersAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditDesigners(state,action){
          state.singleDesigners=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleDesigners=[]
      },
      setChnageStatus(state,action){
        state.singleData=state.data.filter((item)=>item._id == action.payload)
        state.singleData[0].status=state.singleData[0].status===1?0:state.singleData[0].status===0?1:''
      },
      setEditData(state,action){
          state.editData=action.payload
      }
    },
  });
  
  export const {setEditData,setChnageStatus, setLoading, setMessage,setError,setData,setDeleteLoad,setDesignersAdd,setAfterDeleteDesigners,setEditDesigners,setBlankSingleData} = designersSlice.actions;
  export default designersSlice.reducer;

  export const getDesignersData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await designersList()
      if (res.data.success) {
          dispatch(setData(res.data.data))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const designersDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await designersAdd(data)
      if(res.data.success) {
         dispatch(setDesignersAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleDesignersDataAction=(id) =>(dispatch)=>{
              dispatch(setEditDesigners(id))
}
export const blankDataAction=() =>(dispatch)=>{
              dispatch(setBlankSingleData())
}
export const designersDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await designersUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const designersEditAction=(id) => async (dispatch)=>{
  try{
    const res= await designersEdit(id)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const designersDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await designersDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteDesigners(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }

  export const statusChangeAction = (id) => async (dispatch) => {
    dispatch(setDeleteLoad(true));
   try {
   const res= await designersStatus(id)
    if (res.data.success) {
     dispatch(setChnageStatus(id))
     dispatch(setDeleteLoad(false));
     dispatch(setMessage(res.data.message))
     message.success(res.data?.message);
} else {
   dispatch(setDeleteLoad(false));
   dispatch(setError(res.data.message));
}
} catch (e){
dispatch(setDeleteLoad(false));
dispatch(setError(e.response.data.message));
message.error(e.response.data.message);
}
};